export const SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE = 'widget.shift-event-details'
